import {useSelector} from "react-redux"
import { jwtDecode } from "jwt-decode"

const useAuth = () => {
    const { token } = useSelector((state) => state.Auth)
  
    if (token) {
        const decoded = jwtDecode(token)  // Call jwtDecode here properly
        const { id, email, name } = decoded.userInfo
        return { id, email, name, token }
    } else {
        return { id: "", email: "", name: "", token: "" }
    }
}

export default useAuth